<template>
  <div class="d-flex flex-column">
    <div class="d-flex w-100">
      <input v-model="postcode" class="form-control search-input" placeholder="Enter post/zip code" type="search"/>
      <div class="form-control search-icon">
        <span v-if="searchingPostcode" class="inline-loader"></span>
        <i v-else class="fas fa-search"></i>
      </div>
    </div>
    <div v-if="showPostcodeResults" class="custom-accordion text-center">
      <search-result v-for="(address, index) in addresses" :key="index" :address="address" @addressClicked="onAddressClicked"></search-result>
      <span v-if="addresses.length === 0" class="text-danger"> No results found </span>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { PostcodeSearchMixin } from '@/mixins/Booking/PostcodeSearchMixin'
import ClientAddressLookupResult from './ClientAddressLookupResult.vue'

export default {
  name: 'ClientAddressLookup',
  mixins: [PostcodeSearchMixin],
  methods: {
    ...mapMutations('BookingUpload', [
      'setClientAddress'
    ]),
    onAddressClicked (address) {
      this.setClientAddress(address)
      this.$emit('selected')
    }
  },
  components: {
    'search-result': ClientAddressLookupResult
  }
}
</script>

<style scoped>
.search-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.search-icon {
  width: max-content;
  padding: 0.375rem 0.75rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
